import { useMemo, useState } from 'react';
export const useGalleryLogic = _ref => {
  let {
    images,
    currentImageIndex,
    biFunctions
  } = _ref;
  const [activeIndex, setActiveIndex] = useState(currentImageIndex);
  const currentImage = useMemo(() => images[activeIndex], [activeIndex, images]);
  const hasMultipleImages = useMemo(() => images.length > 1, [images]);
  const goToPrevious = () => {
    biFunctions.onPrevious();
    setActiveIndex(prev => prev > 0 ? prev - 1 : images.length - 1);
  };
  const goToNext = () => {
    biFunctions.onNext();
    setActiveIndex(prev => prev < images.length - 1 ? prev + 1 : 0);
  };
  return {
    currentImage,
    goToPrevious,
    goToNext,
    hasMultipleImages,
    activeIndex
  };
};
//# sourceMappingURL=Gallery.logic.js.map